import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CultureInsertService {

  private apiUrl = globalConst.baseAPI;
  constructor(private http: Http) { }

  insertCulture(token, culture: any) {
  	console.log(culture);

  	return this.http
  		.post(this.apiUrl + "culture/v1/insertculture", culture, JSON.parse(localStorage.getItem('yara.connectionHeader')))
  		.map((res: Response) => res.json())
  		.catch(e => {
  			if (e.status === 401) {
  				return Observable.throw('Unauthorized');
  			}
  		});
  }

}



// WEBPACK FOOTER //
// ./src/app/culture/service/culture-insert/culture-insert.service.ts